module.exports = __webpack_public_path__ + "img/save.9cabd941.svg";